import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
    AppBar,
    Toolbar,
    Box,
    Typography,
    Button,
    Container,
} from '@mui/material';
import { useAuth } from '../hooks/useAuth';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

export const Navbar: React.FC = () => {
    const { user } = useAuth();
    const { t } = useTranslation();
    const location = useLocation();
    const alwaysShowAuth = ['/login', '/verification-pending'].includes(location.pathname);

    return (
        <AppBar position="static" sx={{ backgroundColor: 'var(--primary-color)' }}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                        <RouterLink to="/" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
                            <Box
                                component="img"
                                src="/SDG.png"
                                alt="SDG Logo"
                                sx={{ width: '40px', marginRight: '10px' }}
                            />
                            <Typography variant="h6" component="div">
                                SDG
                            </Typography>
                        </RouterLink>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 2 }, '& > *': { ml: { xs: 1, sm: 2 } } }}>
                        <LanguageSelector />
                        {alwaysShowAuth ? (
    <>
        <Button
            component={RouterLink}
            to="/login"
            color="inherit"
            variant="outlined"
            sx={{ 
                borderColor: 'white',
                minWidth: '120px',
                '&:hover': {
                    borderColor: 'white',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
            }}
        >
            {t('common.login')}
        </Button>
        <Button
            component={RouterLink}
            to="/register"
            color="inherit"
            variant="outlined"
            sx={{ 
                borderColor: 'white',
                minWidth: '120px',
                '&:hover': {
                    borderColor: 'white',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
            }}
        >
            {t('common.register')}
        </Button>
    </>
) : user ? (
    <>
        <Button
            component={RouterLink}
            to="/dashboard"
            color="inherit"
        >
            {t('common.dashboard')}
        </Button>
        <Button
            component={RouterLink}
            to="/profile"
            color="inherit"
        >
            {t('common.profileLink')}
        </Button>
    </>
) : (
    <>
        <Button
            component={RouterLink}
            to="/login"
            color="inherit"
            variant="outlined"
            sx={{ 
                borderColor: 'white',
                minWidth: '120px',
                '&:hover': {
                    borderColor: 'white',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
            }}
        >
            {t('common.login')}
        </Button>
        <Button
            component={RouterLink}
            to="/register"
            color="inherit"
            variant="outlined"
            sx={{ 
                borderColor: 'white',
                minWidth: '120px',
                '&:hover': {
                    borderColor: 'white',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
            }}
        >
            {t('common.register')}
        </Button>
    </>
)}
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Navbar;
